/* eslint-disable no-console */
<template>
  <div>
    <b-form @submit.prevent="campaignSearchReach">
      <b-form-row class="mb-2">
        <b-col
          sm="6"
          md="6"
          lg="2"
          class="d-flex flex-column justify-content-center"
        >
          <label for="reach-date-from">Consumption date from</label>
          <p class="d-inline-block fontsizeconsumptionp mb-0">
            {{ dateFrom }}
          </p>
        </b-col>

        <b-col
          sm="6"
          md="6"
          lg="2"
          class="d-flex flex-column justify-content-center"
        >
          <label for="reach-date-to">Consumption date to</label>
          <p class="d-inline-block fontsizeconsumptionp mb-0">
            {{ dateTo }}
          </p>
        </b-col>

        <b-col
          sm="6"
          md="6"
          lg="2"
          class="d-flex flex-column justify-content-end"
          style="min-width: 13.5rem;"
        >
          <label for="target-group">Reach criteria</label>
          <b-form-select
            id="target-group"
            v-model="minViewingTimeSelection"
            :options="minViewingTimeOptions"
            size="sm"
          />
        </b-col>

        <b-col
          sm="6"
          md="6"
          lg="2"
          class="d-flex"
        >
          <b-button
            id="refresh-reach"
            type="submit"
            class="mt-auto"
            variant="primary"
            size="sm"
          >
            <b-icon icon="arrow-repeat" /> Update
          </b-button>
        </b-col>
      </b-form-row>
      <b-form-row
        v-if="autoChangeEndDate"
        class="mb-2 redText"
      >
        <b-col
          sm="12"
          md="6"
          lg="4"
        >
          <span>Your selection exceeded the limitation that the consumption period may be a maximum of 28 days for reach & frequency. We have therefore automatically adjusted the end date to a shorter interval.</span>
        </b-col>
      </b-form-row>
    </b-form>

    <div
      v-if="loadingCampaign && hasMeasures"
      class="text-center mb-2"
    >
      <hr>
      <b-spinner
        variant="primary"
        type="grow"
        label="Spinning"
      />
      <div>
        <small class="text-muted">Loading reach and frequency...</small>
      </div>
    </div>
    <div v-else-if="hasMeasures">
      <hr>
      <p class="mb-0">
        <small>
          Number of film codes:
          <span class="font-weight-bold">
            {{ numberOfUniqueFilmCodesInQueryKeys }}
          </span>
        </small>
      </p>
      <p class="mb-0">
        <small>
          Number of dates/response rows:
          <span class="font-weight-bold"> {{ numberOfDateRowsInResult }} </span>
        </small>
      </p>
      <p>
        <small>
          Panel day: <span class="font-weight-bold"> {{ panelDayCampaign }} </span>
        </small>
      </p>
      <div class="d-flex">
        <b-form-radio-group
          v-model="measureTypeSelected"
          class="mr-auto"
          :options="measureTypeOptions"
          name="Relative or absolute"
          buttons
          button-variant="outline-primary"
        />
        <CampaignReachExport
          :json="itemsCampaign"
          :header-items="headerItems"
        />
      </div>

      <b-table
        v-if="meassureType === 'absolute_reach'"
        id="reach-summary"
        class="mt-2"
        :bordered="true"
        :striped="true"
        :head-variant="'dark'"
        :items="itemsCampaign"
        :fields="fieldsAbsCampaign"
        :small="true"
        :responsive="true"
      />

      <b-table
        v-else-if="meassureType === 'relative_reach'"
        id="reach-summary"
        class="mt-2"
        :bordered="true"
        :striped="true"
        :head-variant="'dark'"
        :items="itemsCampaign"
        :fields="fieldsRelCampaign"
        :small="true"
        :responsive="true"
      />
    </div>
    <div
      v-else
      class="text-center mb-2"
    >
      <hr>
      <small
        class="text-danger"
      ><strong>You must select a target group under target / metric</strong></small>
    </div>
  </div>
</template>

<script>
import CampaignReachExport from '../../Layout/Campaign/CampaignReachExport';
import { daysBetween, addDays } from '../../../assets/js/utils.js';
import { mapGetters } from 'vuex';

export default {
  name: 'CampaignReach',
  components: {
    CampaignReachExport,
  },
  computed: {
    ...mapGetters([
      'itemsCampaign',
      'loadingCampaign',
      'fieldsAbsCampaign',
      'fieldsRelCampaign',
      'uniSizeCampaign',
      'resultCountCampaign',
      'panelDayCampaign',
    ]),
    minViewingTimeSelection: {
      get() {
        return this.$store.state.campaignReachForm.min_viewing_time.selected;
      },
      set(value) {
        this.$store.commit('campaignReachForm/updateMinViewingTimeCampaign', value);
        this.$store.commit('campaignReachApiBody/updateMinViewingTime', value);
      },
    },
    minViewingTimeOptions() {
      return this.$store.state.campaignReachForm.min_viewing_time.options;
    },
    measureTypeSelected: {
      get() {
        return this.$store.state.campaignReachForm.measure_type.selected;
      },
      set(value) {
        this.meassureType = value;
        this.$store.commit('campaignReachForm/updateMeasureTypeCampaign', value);
        this.$store.commit('campaignReachApiBody/updateMeasureType', value);
      },
    },
    measureTypeOptions() {
      return this.$store.state.campaignReachForm.measure_type.options;
    },
    dateFrom: {
      get() {
        return this.$store.state.campaignReachApiBody.payload.start_date;
      },
    },
    dateTo: {
      get() {
        return this.$store.state.campaignReachApiBody.payload.end_date;
      },
    },
    hasMeasures() {
      let campaignMeasures = this.$store.state.campaignReachApiBody.payload.measures;
      return campaignMeasures.length > 0;
    },
    numberOfSelectedRows() {
      return this.$store.state.campaignReachApiBody.payload.queryKeys.length;
    },
    numberOfUniqueFilmCodesInQueryKeys() {
      let queryKeys = this.$store.state.campaignReachApiBody.payload.queryKeys.map(function(i) {
        return i.split(';');
      });
      let uniqueFilmCodes = [...new Set(queryKeys.map(item => item[0]))];
      return uniqueFilmCodes.length;
    },
    numberOfDateRowsInResult() {
      let dates = this.itemsCampaign.filter(function(reachRow) {
        let date = new Date(reachRow.date_key);
        let isValidDate = !isNaN(date.getTime());
        return isValidDate;
      });
      return dates.length;
    },
    autoChangeEndDate() {
      return this.$store.state.campaignReachApiBody.autoChangeEndDate;
    },
    headerItems() {
      return [
        {
          date_key: 'Period',
          measure_1: `${this.dateFrom}--${this.dateTo}`,
        },
        {
          date_key: 'Panel day',
          measure_1: this.panelDayCampaign,
        },
        {
          date_key: 'Number of film codes',
          measure_1: this.numberOfUniqueFilmCodesInQueryKeys,
        },
        {
          date_key: 'Number of dates/response rows',
          measure_1: this.numberOfDateRowsInResult,
        },
      ];
    },
  },
  data() {
    return {
      meassureType: 'absolute_reach',
    };
  },
  watch: {
    '$store.state.campaignReachResults.showToastErrorCampaign'() {
      if (this.$store.state.campaignReachResults.showToastErrorCampaign) {
        this.$bvToast.toast('Unknown server error when fetching ad reach & frequency results', {
          title: 'Error',
          variant: 'danger',
          solid: true,
          autoHideDelay: 5000,
          bodyOutputType: 'trustedHtml',
        });
        this.$store.state.campaignReachResults.showToastErrorCampaign = false;
      }
    },
  },
  methods: {
    campaignSearchReach() {
      if (this.minViewingTimeSelection == -1) {
        this.$bvToast.toast('You must select a reach criteria.', {
          title: 'Invalid reach criteria',
          variant: 'danger',
          solid: true,
          autoHideDelay: 5000,
          bodyOutputType: 'trustedHtml',
        });
        return;
      }
      let startDate = this.$store.state.campaignReachApiBody.payload.start_date;
      let endDate = this.$store.state.campaignReachApiBody.payload.end_date;
      let days = daysBetween(startDate, endDate);
      //Max days in reach is 28
      if (days >= this.config_MaxReachDays) {
        endDate = addDays(startDate, this.config_MaxReachDays - 1);
        this.$store.commit('campaignReachApiBody/updateAutoChangeEndDate', true);
        this.$store.commit('campaignReachApiBody/updateEndDate', endDate);
      } else {
        this.$store.commit('campaignReachApiBody/updateAutoChangeEndDate', false);
      }

      this.$emit('onCampaignSearchReach');
    },
    round(value, precision) {
      let multiplier = Math.pow(10, precision || 0);
      let rounded = Math.round(value * multiplier) / multiplier;
      return rounded.toString().replace('.', ',');
    },
  },
};
</script>
<style scoped>
.fontsizeconsumptionp {
  font-size: 0.875rem;
}
.redText {
  color: red;
  font-weight: bold;
  font-size: 0.8em;
}
</style>